function trackAmplitudeEvent() {
  document.querySelectorAll('.amplitude-tracking:not([data-amplitude-tracked])').forEach((trackingElm) => {
    trackingElm.setAttribute('data-amplitude-tracked', 'true');

    const eventType = trackingElm.dataset.amplitudeEventType;
    let eventProperties = {};
    try {
      eventProperties = JSON.parse(trackingElm.dataset.amplitudeEventProperties || '{}');
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Amplitude: failed to parse event properties', e);
    }
    const pageUrl = trackingElm.dataset.amplitudePageUrl;
    const locale = document.querySelector('html').getAttribute('lang');
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

    fetch('/api/v1/amplitude_events', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Accept-Language': locale,
        'X-CSRF-Token': csrfToken,
      },
      body: JSON.stringify({
        event_type: eventType,
        event_properties: eventProperties,
        page_url: pageUrl,
      }),
    }).catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Amplitude tracking error:', error);
    });
  });
}

document.addEventListener('DOMContentLoaded', trackAmplitudeEvent);
document.addEventListener('turbo:load', trackAmplitudeEvent);
